export const appRouteConstants = {

    AUTH: {
        LOGIN: "login",
        RESET: "reset-password",
        RESET_REQUEST: "reset-req",
        RESET_PASSWORD_PROFILE_REQUEST: "hr/reset-password-profile"

    },
    JOINING_FORM: {
        FORM: "join/"
    },
    HOME: "home",
    EMPLOYEEMANAGEMENT: {
        EMPLOYEES: {
            EMPLOYEE: "hr/employee-management/employees/details/",
            ALL_EMPLOYEES: "hr/employee-management/employees"
        },
        VENDORS: {
            VENDOR: "hr/employee-management/vendors/details/",
            ALL_VENDORS: "hr/employee-management/vendors"
        },
        PROJECTS: {
            PROJECT: "hr/employee-management/projects/details/",
            ALL_PROJECTS: "hr/employee-management/projects"
        },
        CLIENTS: {
            CLIENT: "hr/employee-management/clients/details/",
            ALL_CLIENTS: "hr/employee-management/clients"
        },
        ONBOARDEMPLOYEES: {
            ONBOARDEMPLOYEE: "hr/employee-management/onboardEmployee/details/",
            ALL_ONBOARDEMPLOYEES: "hr/employee-management/onboardEmployee"
        },
        PREJOIN: {
            ALL_PREJOIN: "hr/employee-management/pre-join",
            PREJOIN_DETAILS: "hr/employee-management/pre-join/details/"
        },
        ATTENDENCE: {
            ATTENDENCE: "hr/employee-management/attendence/details/",
            ALL_ATTENDENCE: "hr/employee-management/attendence"
        },

        MANAGERABSENCE: {
            ALL_ABSENCE: "hr/employee-management/employee-absences",
            ABSENCE: "hr/employee-management/employee-absences/details/",
        }
    },
    PROPERTYMANAGEMENT: {
        PROPERTIES: {
            PROPERTY: "hr/property-management/property/details/",
            ALL_PROPERTIES: "hr/property-management/property"
        },
        PROPERTY_SUITES: {
            PROPERTY_SUITE: "hr/property-management/propertysuite/details/",
            ALL_PROPERTY_SUITES: "hr/property-management/propertysuite"
        },
    },
    DASHBOARD: "hr/Dashboard",
    TIMESHEET:
    {
        ALL_TIMESHEET: "hr/timesheet-management",
        TIMESHEET: "hr/timesheet-management/timesheetDetail/",
        TIMESHEET_DETAIL: "hr/timesheet-management/timeSheetDetailView/",
    },
    IMMIGRATIONS: {
        IMMIGRATION: "hr/immigration/details/",
        ALL_IMMIGRATION: "hr/immigration"
    },
    ANOUNCEMENT: {
        ANOUNCEMENT: "hr/settings/anouncement/details/",
        ALL_ANOUNCEMENT: "hr/settings/anouncement"
    },
    HELPDESK: {
        HELPDESK: "hr/settings/helpdesk/details/",
        ALL_HELPDESK: "hr/settings/helpdesk"
    },
    SALESREP: {
        SALESREP: "hr/settings/salesRep/details/",
        ALL_SALESREP: "hr/settings/salesRep"
    },
    LEADREP: {
        LEADREP: "hr/settings/leadRep/details/",
        ALL_LEADREP: "hr/settings/leadRep"
    },
    ACCOUNTMANAGER: {
        ACCOUNTMANAGER: "hr/settings/accounts/details/",
        ALL_ACCOUNTMANAGER: "hr/settings/accounts"
    },
    CONFIG: {
        CONFIG: "hr/settings/config/details/",
        ALL_CONFIG: "hr/settings/config"
    },
    ROLES: {
        ROLE: "hr/settings/roles/details/",
        ALL_ROLES: "hr/settings/roles"
    },
    DEPARTMENTS: {
        DEPARTMENT: "hr/settings/departments/details/",
        ALL_DEPARTMENTS: "hr/settings/departments"
    },
    PAYROLL: {
        ADVANCE: {
            ALL_ADVANCE: "hr/payroll-management/advance",
            ADVANCE: "hr/payroll-management/advance/details/"
        },
        REFUNDS: {
            ALL_REFUNDS: "hr/payroll-management/refund",
            REFUND: "hr/payroll-management/refund/details/"
        },
        EXPENSES: {
            ALL_EXPENSES: "hr/payroll-management/expenses",
            EXPENSE: "hr/payroll-management/expenses/details/"
        },
        PAYSTUBS: {
            PAYSTUB: "hr/payroll-management/paystubs"
        },
        INSURANCE: {
            ALL_INSURANCE: "hr/payroll-management/insurance",
            INSURANCE: "hr/payroll-management/insurance/details/"

        },
        PAYROLLUPDATE: {
            ALL_PAYROLLUPDATE: "hr/payroll-management/payrollUpdate",
            PAYROLLUPDATE: "hr/payroll-management/payrollUpdate/details/"

        },
        ELECTRONIC: {
            ALL_CHECKS: "hr/payroll-management/electronic",
            ELECTRONIC_CHECK: "hr/payroll-management/electronic/details/"
        },
        MANUAL: {
            ALL_CHECKS: "hr/payroll-management/manual",
            MANUAL_CHECK: "hr/payroll-management/manual/details/"
        },
        BANKDEPOSITS: {
            ALL_BANKDEPOSIT: "hr/payroll-management/bankDeposit",
            BANK_DEPOSIT: "hr/payroll-management/bankDeposit/details/"
        },
        PAYROLLRECORDS: {
            ALL_PAYROLLRECORD: "hr/payroll-management/payrollRecord",
            PAYROLL_RECORD: "hr/payroll-management/payrollRecord/details/"
        }
    },
    SALES: {
        DEMAND: {
            ALL_DEMAND: "hr/sales-management/demands",
            DEMAND: "hr/sales-management/demands/details/"
        },
        RESOURCE: {
            ALL_RESOURCE: "hr/sales-management/resources",
            RESOURCE: "hr/sales-management/resources/details/"
        },
        DEMANDROLE: {
            ALL_DEMAND_ROLE: "hr/sales-management/roles",
            DEMAND_ROLE: "hr/sales-management/roles/details/"
        },
        BENCHCANDIDATE: {
            ALL_RAW_BENCH_CANDIDATES: "hr/bench-sales-management/benchEmployees/raw",
            ALL_TRAINING_BENCH_CANDIDATES: "hr/bench-sales-management/benchEmployees/training",
            ALL_MARKETING_CANDIDATES: "hr/bench-sales-management/benchEmployees/marketing",
            ALL_PLACEMENT_CANDIDATES: "hr/bench-sales-management/benchEmployees/placement",
            ALL_DECLINED_CANDIDATES: "hr/bench-sales-management/benchEmployees/declined",
            ALL_SALESREP_CANDIDATES: "hr/bench-sales-management/benchEmployees/salesRep",

            BENCHCANDIDATE: "hr/bench-sales-management/benchEmployees/details/"
        },
        BENCHLEAD: {
            ALL_BENCHLEAD: "hr/bench-sales-management/benchLeads",

            BENCHLEAD: "hr/bench-sales-management/benchLeads/details/"
        }
    },
    USEREMANAGEMENT: {
        USERS: {
            USER: "hr/user-management/users",
            DETAILED_USER: "hr/user-management/users/details/",
        }
    },
    INSURANCEPROVIDER: {
        INSURANCEPROVIDER: "hr/settings/insuranceProvider/details/",
        ALL_INSURANCEPROVIDER: "hr/settings/insuranceProvider"
    },
    HMFLOW: {
        CANDIDATE: {
            ALL_CANDIDATE: "hr/hr-management/candidates",
            CANDIDATE: "hr/hr-management/candidates/details/"
        },
        JOBCODE: {
            ALL_JOBCODE: "hr/hr-management/jobcodes",
            JOBCODE: "hr/hr-management/jobcodes/details/"
        },
        JOBSUBMISSION: {
            ALL_JOBSUBMISSION: "hr/hr-management/jobsubmissions",
            JOBSUBMISSION: "hr/hr-management/jobsubmissions/details/"
        },
        INTERVIEWPANEL: {
            ALL_INTERVIEWPANEL: "hr/hr-management/interviewPanel",
            INTERVIEWPANEL: "hr/hr-management/interviewPanel/details/"
        },  
        INTERVIEW: {
            ALL_INTERVIEW: "hr/hr-management/interviews",
            SCHEDULE: "hr/hr-management/interviews/schedule",
            INTERVIEW: "hr/hr-management/interviews/details/"
        },   
    },
    HMFLOWSETTING: {
        CLIENTSPOC: {
            CLIENTSPOC: "hr/hmflowsettings/clientspocs/details/",
            ALL_CLIENTSPOCS: "hr/hmflowsettings/clientspocs"
        },
        CLIENTSPOCCLIENTS: {
            CLIENTSPOCCLIENT: "hr/hmflowsettings/clients/details/",
            ALL_CLIENTSPOCCLIENTS: "hr/hmflowsettings/clients"
        },
    }

};
